<template>
    <div class="contenedor-programacion-default">
        <v-container fluid>
            <v-card
                class="mb-4"
                flat>
                <v-card-text>
                <titulo-tool-bar></titulo-tool-bar>
                <tool-bar
                    class="mb-4"
                    v-on:nuevoOficio="registrarNuevoOficio"
                    :filtros="filtros"
                    :listaOficiosAutorizacion="getOficiosPresupuesto"
                    :ejercicio ="getEjercicio"
                    >
                </tool-bar>
                </v-card-text>
            </v-card>
            <v-card flat>
                <v-card-text>
                    <listado
                    :listadoOficiosAutorizacion="getListaOficiosAutorizacion"></listado>
                </v-card-text>
            </v-card>
        </v-container>
        <v-dialog
        persistent
        v-model="mostrarVentanaRegistrarNuevoOficio"
        :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
          <registrar-nuevo-oficio
              v-if="mostrarVentanaRegistrarNuevoOficio"
              v-on:cerrar="cerrarRegistrarNuevoOficio">
          </registrar-nuevo-oficio>
        </v-dialog>
        <v-dialog
        v-if="oficioAutorizacionEditar"
        persistent
        v-model="mostrarVentanaEditarOficioAutorizacion"
        :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
          <editar-oficio
              :oficioAutorizacionEditar="oficioAutorizacionEditar"
              v-on:cerrar="cerrarEditarOficio">
          </editar-oficio>
        </v-dialog>
        <v-dialog
        persistent
        v-model="mostrarVentanaEliminarOficioAutorizacionDetalle"
        width="450">
          <eliminar-detalle
            :oficioAutorizacionDetalleEliminar="oficioAutorizacionDetalleEliminar"
            v-on:cerrar="cerrarEliminarOficioDetalle"
          >
          </eliminar-detalle>
        </v-dialog>
        <v-dialog
        persistent
        v-model="mostrarVentanaEliminarOficioAutorizacion"
        width="450">
          <eliminar-oficio
          :oficioAutorizacionEliminar="oficioAutorizacionEliminar"
          v-on:cerrar="cerrarEliminarOficio">

          </eliminar-oficio>

        </v-dialog>
    </div>
</template>
<script>
import OFICIOS_AUTORIZACION from '@/graphql/querys/administracion/programacion/oficiosautorizacion/oficiosautorizacion.gql';
import PRESUPUESTOS from '@/graphql/querys/administracion/presupuestos/presupuestos.gql';
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratos.gql';
import TituloToolBar from '@/views/administracion/programacion/TituloToolBar.vue';
import ToolBar from '@/views/administracion/programacion/ToolBar.vue';
import Listado from '@/views/administracion/programacion/listado/Main.vue';
import RegistrarNuevoOficio from '@/components/administracion/programacion/oficiosautorizacion/Nuevo.vue';
import EliminarDetalle from '@/components/administracion/programacion/oficiosautorizacion/oficiosautorizaciondetalle/Eliminar.vue';
import EliminarOficio from '@/components/administracion/programacion/oficiosautorizacion/Eliminar.vue';
import EditarOficio from '@/components/administracion/programacion/oficiosautorizacion/Editar.vue';
import eventBus from '@/helpers/eventBus';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'ProgramacionDefault',
  mixins: [mixFormatoEstructura],
  components: {
    TituloToolBar,
    ToolBar,
    Listado,
    RegistrarNuevoOficio,
    EliminarDetalle,
    EliminarOficio,
    EditarOficio,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoOficio: false,
      mostrarVentanaEditarOficioAutorizacion: false,
      mostrarVentanaEliminarOficioAutorizacionDetalle: false,
      mostrarVentanaEliminarOficioAutorizacion: false,
      oficioAutorizacionDetalleEliminar: {},
      oficioAutorizacionEliminar: {},
      oficioAutorizacionEditar: {},
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
      },
    };
  },
  apollo: {
    oficiosAutorizacion: {
      query: OFICIOS_AUTORIZACION,
    },
    presupuestos: {
      query: PRESUPUESTOS,
    },
    contratos: {
      query: CONTRATOS,
    },
  },
  mounted() {
    eventBus.$on('eliminar-oficio-autorizacion-detalle', (oficioAutorizacionDetalle) => {
      this.oficioAutorizacionDetalleEliminar = oficioAutorizacionDetalle;
      this.mostrarVentanaEliminarOficioAutorizacionDetalle = true;
    });
    eventBus.$on('eliminar-oficio-autorizacion', (oficioAutorizacion) => {
      this.oficioAutorizacionEliminar = oficioAutorizacion;
      this.mostrarVentanaEliminarOficioAutorizacion = true;
    });
    eventBus.$on('editar-oficio-autorizacion', (oficioAutorizacion) => {
      this.oficioAutorizacionEditar = oficioAutorizacion;
      this.mostrarVentanaEditarOficioAutorizacion = true;
    });
  },
  computed: {
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos;
    },
    getEjercicio() {
      if (!this.getListaOficiosAutorizacion || this.getListaOficiosAutorizacion.length === 0) return '';
      return this.getListaOficiosAutorizacion[0].ejercicio.toString();
    },
    getPresupuestos() {
      if (!this.presupuestos) return [];
      return this.presupuestos;
    },
    getOficiosAutorizacion() {
      if (!this.oficiosAutorizacion) return [];
      return this.oficiosAutorizacion;
    },
    getOficiosPresupuesto() {
      if (!this.getListaOficiosAutorizacion) return [];
      const oficiosPresupuesto = this.getListaOficiosAutorizacion
        .map((general) => general.detalles
          .map((detalle) => {
            // Obtener la clave en Presupuesto Detalle
            let claveObraPresupuestoDetalle = this.getPresupuestos
              .map((presupuesto) => {
                const presupuestoClave = presupuesto.detalles
                  .find((det) => det.id === detalle.idFuenteFinanciera);
                if (presupuestoClave) {
                  return presupuestoClave.claveObra;
                }
                return '';
              })
              .filter((item) => item !== '');

            // Obtener contrato si la obra aparece en uno
            let contratoObra = this.getContratos
              .map((contrato) => {
                const claveContrato = contrato.obras
                  .find((obra) => obra.idObra === detalle.idObra);
                if (claveContrato) return contrato.numero;
                return '';
              })
              .filter((item) => item !== '');
            contratoObra = contratoObra.toString();
            claveObraPresupuestoDetalle = claveObraPresupuestoDetalle.toString();
            const claveObraPresupuesto = {
              value: claveObraPresupuestoDetalle || '',
              estilo: {
                alignment: {
                  horizontal: 'left',
                  vertical: 'center',
                },
              },
            };
            const tipoDetalle = general.tipo ? general.tipo.substring(0, 1) : '';
            let importeDetalle = detalle.importe ? detalle.importe : 0;
            let colorDetalle = '000000';
            if (tipoDetalle === 'C') {
              importeDetalle *= -1;
              colorDetalle = '#FA8B00';
            }
            const tipo = {
              value: tipoDetalle,
              estilo: {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
                font: {
                  size: 12,
                  bold: true,
                  color: colorDetalle,
                },
              },
            };
            const importe = {
              value: importeDetalle,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                  color: colorDetalle,
                },
                alignment: {
                  horizontal: 'right',
                  vertical: 'center',
                },
                numberFormat: '#,##0.00',
              },
            };
            const clavePresupuestal = {
              value: detalle.clavePresupuestal || '',
              estilo: {
                alignment: {
                  horizontal: 'left',
                  vertical: 'center',
                },
              },
            };
            const meta = {
              value: detalle.obra.meta || '',
              estilo: {
                alignment: {
                  horizontal: 'left',
                  vertical: 'center',
                  shrinkToFit: false,
                  wrapText: false,
                },
              },
            };
            const claveObraPlaneacion = {
              value: detalle.obra.clave || '',
              estilo: {
                alignment: {
                  horizontal: 'left',
                  vertical: 'center',
                },
              },
            };
            const fecha = {
              value: general.fecha || '',
              estilo: {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
              },
            };
            const numero = {
              value: general.numero || '',
              estilo: {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
              },
            };
            const contrato = {
              value: contratoObra || '',
              estilo: {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
              },
            };
            return {
              claveObraPlaneacion,
              meta,
              importe,
              clavePresupuestal,
              claveObraPresupuesto,
              numero,
              fecha,
              tipo,
              contrato,
            };
          }))
        .flat();
      return oficiosPresupuesto;
    },
    getListaOficiosAutorizacion() {
      if (!this.oficiosAutorizacion) return [];
      return this.oficiosAutorizacion
        .map((oficio) => ({ ...oficio, ejercicio: new Date(`${oficio.fecha} 00:00:00`).getFullYear() }))
        .sort((a, b) => new Date(`${b.fecha} 00:00:00`) - new Date(`${a.fecha} 00:00:00`))
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        .filter(({ tipo }) => {
          const { tipos } = this.filtros;
          if (this.filtros.tipos.length <= 0) return true;
          return tipos.includes(tipo);
        })
        .filter((oficio) => {
          if (!this.filtros.buscarTexto) return oficio;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(oficio.numero);
          return (
            expt.test(numero)
            || expt.test(oficio.numero)
          );
        });
    },
  },
  methods: {
    registrarNuevoOficio() {
      this.mostrarVentanaRegistrarNuevoOficio = true;
    },
    cerrarRegistrarNuevoOficio() {
      this.mostrarVentanaRegistrarNuevoOficio = false;
    },
    cerrarEliminarOficioDetalle() {
      this.mostrarVentanaEliminarOficioAutorizacionDetalle = false;
    },
    cerrarEliminarOficio() {
      this.mostrarVentanaEliminarOficioAutorizacion = false;
    },
    cerrarEditarOficio() {
      this.mostrarVentanaEditarOficioAutorizacion = false;
      this.oficioAutorizacionEditar = null;
    },
  },
};
</script>
